export const GET_LOCATION = 'get_location';
export const GET_LOCATIONS_SUCCESS = 'get_locations_success';
export const SELECTED_LOCATION_SUCCESS = 'selected_location_success';
export const TIME_SLOT_AND_LOCATION = 'time_slot_and_location';
